import { SOCIAL_BASE_URL } from './constants';

export const generateWhatsAppShareURL = (textMessage, productURL, utmSource) => {
  const baseURL = SOCIAL_BASE_URL.whatsapp;
  const encodedProductURL = encodeURIComponent(productURL);
  const encodedUTMSource = encodeURIComponent(utmSource);
  const fullURL = `${baseURL}text=${encodeURIComponent(
    textMessage
  )}%20${encodedProductURL}&source=${encodedUTMSource}`;
  return fullURL;
};
export const generateFacebookShareURL = (productURL, textMessage, utmSource) => {
  const baseURL = SOCIAL_BASE_URL.facebook;
  const encodedProductURL = encodeURIComponent(productURL);
  const encodedTextMessage = encodeURIComponent(textMessage);
  const encodedUTMSource = encodeURIComponent(utmSource);
  const fullURL = `${baseURL}?u=${encodedProductURL}&p[title]=${encodedTextMessage}&utm_source=${encodedUTMSource}`;
  return fullURL;
};

export const generateTwitterWebIntentURL = (productURL, textMessage, utmSource) => {
  const baseURL = SOCIAL_BASE_URL.twitter;
  const encodedProductURL = encodeURIComponent(productURL);
  const encodedTextMessage = encodeURIComponent(textMessage);
  const encodedUTMSource = encodeURIComponent(utmSource);
  const fullURL = `${baseURL}?text=${encodedTextMessage}&url=${encodedProductURL}&utm_source=${encodedUTMSource}`;
  return fullURL;
};

export const generateTelegramShareLink = (productURL, textMessage, utmSource) => {
  const baseURL = SOCIAL_BASE_URL.telegram;
  const encodedProductURL = encodeURIComponent(productURL);
  const encodedTextMessage = encodeURIComponent(textMessage);
  const encodedUTMSource = encodeURIComponent(utmSource);
  const fullURL = `${baseURL}?text=${encodedTextMessage}&url=${encodedProductURL}&utm_source=${encodedUTMSource}`;
  return fullURL;
};

export function fallbackCopyTextToClipboard(text, customText = '') {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    return true;
  } catch (err) {
    return false;
  }

  document.body.removeChild(textArea);
}

export async function copyTextToClipboard(text, isCopied) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return false;
  }
  const res = navigator.clipboard.writeText(text).then(
    function () {
      isCopied(true);
    },
    function (err) {
      isCopied(false);
    }
  );
  return res;
}
